import React from "react";
import { FormattedMessage } from "react-intl";
import { MessageBanner } from "@folio/stripes/components";
import { config } from "stripes-config";
import { NK_CONTACTS_URL } from "./RegistrationContactNotice";
import css from "./RegistrationPrivacyNotice.module.css";
/** Global Register of Publishers maintained by the International ISBN Agency. */
export var GRP_URL = "https://grp.isbn-international.org/";
/** International ISMN database of music publishers maintained by the International ISMN Agency. */
export var ISMN_DIRECTORY_URL = "https://ismn-international.org/ismn/directory/";
/** Guide to the registration form for publishers receiving ISBN/ISMN on an ongoing basis. */
export var GUIDE_CONTINUOUS_URL = "https://info-recek.nkp.cz/o-systemu-recek/navody/registrace/registrace-isbn-ismn-soustavne/";
/** Guide to the registration form for one-off ISBN/ISMN assignment. */
export var GUIDE_ONE_TIME_URL = "https://info-recek.nkp.cz/o-systemu-recek/navody/registrace/registrace-isbn-ismn-jednorazove/";
var PUBLISHERS_DIRECTORY_PATH = "/publishers";
/**
 * Publishers directory of the environment's public catalog, or null when the build configured
 * no catalog (`config.publicCatalogUrl` from stripes-config).
 */
export var publishersDirectoryUrl = function (catalogUrl) {
    var base = typeof catalogUrl === "string" ? catalogUrl.trim().replace(/\/+$/, "") : "";
    return base ? "".concat(base).concat(PUBLISHERS_DIRECTORY_PATH) : null;
};
var newTabLink = function (href) { return function (chunks) { return (React.createElement("a", { href: href, target: "_blank", rel: "noopener noreferrer" }, chunks)); }; };
var plainText = function (chunks) { return React.createElement(React.Fragment, null, chunks); };
/**
 * Always-visible information on the publisher registration form: which of the filled-in publisher
 * details become public (national directory, international ISBN/ISMN registers), whom to contact,
 * and where the guides to the form are.
 */
export var RegistrationPrivacyNotice = function () {
    var directoryUrl = publishersDirectoryUrl(config.publicCatalogUrl);
    return (React.createElement("div", { className: css.notice },
        React.createElement(MessageBanner, { className: css.info, icon: "info" },
            React.createElement("p", { className: css.paragraph },
                React.createElement(FormattedMessage, { id: "stripes-core.publishers.register.privacyNotice.publicData", values: {
                        directory: directoryUrl ? newTabLink(directoryUrl) : plainText,
                        grp: newTabLink(GRP_URL),
                        ismn: newTabLink(ISMN_DIRECTORY_URL),
                    } }),
                React.createElement("br", null),
                React.createElement(FormattedMessage, { id: "stripes-core.publishers.register.privacyNotice.contact", values: { contact: newTabLink(NK_CONTACTS_URL) } })),
            React.createElement("p", { className: css.paragraph },
                React.createElement(FormattedMessage, { id: "stripes-core.publishers.register.privacyNotice.guide", values: {
                        continuous: newTabLink(GUIDE_CONTINUOUS_URL),
                        oneTime: newTabLink(GUIDE_ONE_TIME_URL),
                    } })))));
};
